/**
 * Razclenitev zneska modula Projekti do knjizb (CLAUDE.md, pravilo 6):
 * datum, konto, vrsta, dokument, nosilec, znesek in opomba.
 */
import type { KnjizbaDelitve } from '@koda/shared';
import type { JSX } from 'react';

import { useBesedilaProjektov } from '../../lib/besedila-projektov';
import { datum, znesek } from '../../lib/format';

interface Lastnosti {
  opis: string;
  knjizbe: KnjizbaDelitve[];
  naZapri: () => void;
}

export function KnjizbeProjekta({ opis, knjizbe, naZapri }: Lastnosti): JSX.Element {
  const b = useBesedilaProjektov();
  return (
    <section className="kartica" aria-label={b.knjizbe(opis)}>
      <div className="glava-kartice">
        <h3>{b.knjizbe(opis)}</h3>
        <button type="button" className="gumb-besedilo" onClick={naZapri}>
          {b.zapri}
        </button>
      </div>
      {knjizbe.length === 0 ? (
        <p className="drobno">{b.brezKnjizb}</p>
      ) : (
        <div className="tabela-ovoj">
          <table>
            <thead>
              <tr>
                <th>{b.datum}</th>
                <th>{b.konto}</th>
                <th>{b.vrsta}</th>
                <th>{b.dokument}</th>
                <th>{b.nosilec}</th>
                <th className="stevilka">{b.znesek}</th>
                <th>{b.opomba}</th>
              </tr>
            </thead>
            <tbody>
              {knjizbe.map((k) => (
                <tr key={k.id}>
                  <td>{datum(k.datum)}</td>
                  <td>{k.konto}</td>
                  <td>{k.vrsta ?? '—'}</td>
                  <td>{k.dokument ?? '—'}</td>
                  <td>{k.nosilec === '' ? '—' : k.nosilec}</td>
                  <td className="stevilka">{znesek(k.znesek)}</td>
                  <td>{k.opomba ?? ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
